import React, { useContext, useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'

import './Rooms.scss'
import Room from './Room'
import { CHAPTERS, ROOMS } from '../../constants'
import OutroRoom from '../OutroRoom'
import IntroRoom from '../IntroRoom/IntroRoom'
import { useCrossfadedLoop } from '../../Sound/useCrossfadedLoop'
import Icon from '../../assets/icons/Icon'
import theme from '../../theme'
import RoomTransition from '../RoomTransition/RoomTransition'
import creditsSound from '../OutroRoom/RED ROOM.mp3'
import { preloadBigBgWithThumbnail } from '../../bigBgImgPreload'
import { UserClickedContext } from '../../App'

const Controls = ({ path, index, children, style }) => {
  const history = useHistory()
  const getName = (roomNumber) => CHAPTERS.find((ch) => ch.id === roomNumber)?.name
  const urlBack = `${path}?name=${getName(index - 1)}`
  const urlForth = index < 8 && `${path}?name=${getName(index + 1)}`

  const onArrowClick = (direction) => () => {
    if (direction === 'back') {
      setTimeout(() => {
        history.push(urlBack)
      }, 250)
    } else {
      setTimeout(() => {
        history.push(urlForth)
      }, 250)
    }
  }

  return (
    <div className="controls" style={style}>
      {urlBack ? (
        <Icon
          name="arrowLeft"
          stroke={theme.white}
          className="back"
          onClick={onArrowClick('back')}
          width="0.8vw"
          height="1.5vw"
        />
      ) : (
        <div style={{ paddingRight: 61 }} />
      )}
      {children}
      {urlForth ? (
        <Icon
          name="arrowRight"
          stroke={theme.white}
          className="forth"
          onClick={onArrowClick('forth')}
          width="0.8vw"
          height="1.5vw"
        />
      ) : (
        <div style={{ paddingRight: 61 }} />
      )}
    </div>
  )
}

const Rooms = () => {
  let location = useLocation()
  const query =
    location.search && location.search.replace('?name=', '').replace('&id=5239d6a0-0425-4432-b6df-d06a3ed66537', '')

  const screenFromQuery = CHAPTERS.find((ch) => ch.name === query).id

  const { t } = useTranslation('common')

  const [imageClicked, setImageClicked] = useState(false)
  const [activeScreen, setActiveScreen] = useState(0 || screenFromQuery)
  const [isClickable, setIsClickable] = useState(false)
  const userClicked = useContext(UserClickedContext)

  const exitFullScreen = () => {
    if (document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    }
  }

  useEffect(() => {
    exitFullScreen()
  }, [])

  useEffect(() => {
    ReactGA.pageview(location?.pathname + location?.search)
  }, [location])

  useEffect(() => {
    console.log(activeScreen)
    preloadBigBgWithThumbnail(activeScreen)
  }, [activeScreen])

  useEffect(() => {
    setActiveScreen(screenFromQuery)
  }, [query, screenFromQuery])

  const { activeSoundsLoaded } = useCrossfadedLoop(
    [...ROOMS.map((story) => story.roomSound), creditsSound],
    userClicked,
    activeScreen,
    imageClicked
  )

  // const activeSoundsLoaded = true

  const TuneIn = (
    <div id="tuneIn">
      <Icon name="play" />
      <span>{t('tuneIn')}</span>
    </div>
  )

  if (activeScreen === 0)
    return (
      <>
        <RoomTransition userClicked={userClicked} activeScreen={activeScreen} i={0} key={0}>
          <IntroRoom activeSoundsLoaded={activeSoundsLoaded} />
        </RoomTransition>
        {activeSoundsLoaded && TuneIn}
      </>
    )

  return (
    <>
      {activeScreen === 8 && (
        <RoomTransition userClicked={userClicked} activeScreen={activeScreen} i={8} key={8}>
          <OutroRoom />
          <Controls style={{ top: ' calc(50% - 50px)' }} path="/chapter" index={activeScreen} />
        </RoomTransition>
      )}
      {ROOMS.map((room, i) => {
        return (
          <RoomTransition userClicked={userClicked} activeScreen={activeScreen} i={i} key={i}>
            <div
              style={{
                backgroundImage: `url(${ROOMS[activeScreen]?.roomImg})`,
              }}
              className="bgContainer slide"
              id="slide"
            >
              <div className="thumbnail" style={{ backgroundImage: `url(${ROOMS[activeScreen]?.roomThumbnail})` }} />
              <div className={`room slide__image ${i === activeScreen ? 'show' : ''}`}>
                <Controls path="/chapter" index={activeScreen}>
                  <Room
                    t={t}
                    screenFromQuery={screenFromQuery}
                    isClickable={isClickable}
                    key={activeScreen}
                    data={room}
                    setIsClickable={setIsClickable}
                    activeSoundsLoaded={activeSoundsLoaded}
                    chapterName={query}
                    setImageClicked={setImageClicked}
                    i={i}
                  />
                </Controls>
              </div>
            </div>
          </RoomTransition>
        )
      })}
      {activeSoundsLoaded && TuneIn}
    </>
  )
}

export default Rooms
